// Libraries
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import SecureLS from 'secure-ls'

// Modules
import modules from './module_loader'
const ls = new SecureLS({ isCompression: false })
Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [
    new VuexPersistence({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      },
      reducer: (state) => ({ auth: state.auth })
    }).plugin
  ]
})
